import { Dialog } from '@flashka/shared/ui';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { nt } from '@/i18n-helpers';

function DialogContact({ email }: { email: string }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="cursor-pointer"
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen(true);
          }
        }}>
        {t('homeV2.footer.contacts')}
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        size="md"
        hug
        title={t('homeV2.contactDialog.contactUs')}
        closeAccessibilityLabel={t('dialog.close')}
        className="z-[100000]">
        <div className="text-sm text-secondary-600">
          {t('homeV2.contactDialog.feelFreeToReachOut')}{' '}
          <span className="font-semibold">{email}</span>
          <div className="mt-4">
            {t('homeV2.contactDialog.joinCommunity')}{' '}
            <Link to="https://discord.gg/eafSXxrB3F" target="_blank">
              {nt('https://discord.gg/eafSXxrB3F')}
            </Link>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default DialogContact;
